import React from 'react'
import { useUpdateAttackEventsTags } from '../api/use-update-attack-events-tags'
import { useAttackEventTags } from '../api/use-attack-event-tags'
import { logError, logSuccess } from '../../toaster'
import { useIntl } from 'react-intl'
import { excludeFrom, TagDialog } from '../../../legacy-design-system/tags'

interface DialogProps {
  organizationUuid: string
  isOpen: boolean
  closeDialog: () => void
  initialTags: string[]
  refreshGridData: () => void
}

interface MutationProps {
  attackEventIDs: string[]
}

export function ModifyAttackEventsTagsDialog({
  organizationUuid,
  attackEventIDs,
  initialTags,
  closeDialog,
  isOpen,
  refreshGridData
}: DialogProps & MutationProps) {
  const { formatMessage } = useIntl()
  const { tags, isLoading, error } = useAttackEventTags(organizationUuid)
  const updateAttackEventsTagsMutation = useUpdateAttackEventsTags({
    onSuccess: () => {
      logSuccess(
        formatMessage({
          id: 'detail_attackEvents_tagsUpdatedSuccessfully'
        })
      )
      refreshGridData()
    },
    onError: () => {
      logError(
        formatMessage({
          id: 'detail_attackEvents_tagsUpdatedFailure'
        })
      )
    }
  })

  const availableTags = error || isLoading ? [] : tags
  const multipleAttackEvents = attackEventIDs.length > 1

  return (
    <TagDialog
      initialAvailableTags={availableTags}
      initialSelectedTags={initialTags}
      onConfirm={(selectedTags) => {
        const add = excludeFrom(selectedTags, initialTags)
        const remove = excludeFrom(initialTags, selectedTags)

        if (add.length + remove.length > 0) {
          updateAttackEventsTagsMutation.mutate({
            organizationUuid,
            ids: attackEventIDs,
            add,
            remove
          })
        }

        closeDialog()
      }}
      onCancel={closeDialog}
      title={formatMessage({
        id: multipleAttackEvents
          ? 'title_attackEvents_tagAttackEvents'
          : 'title_attackEvents_tagAttackEvent'
      })}
      isOpen={isOpen}
    />
  )
}
